module.exports = __webpack_public_path__ + "img/Group-34115.4f0fde10.svg";